import { useContext, useEffect, useState } from 'react';
import { EditContext } from '../context/EditContext';

export function useServices() {
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);
  const { configVersion } = useContext(EditContext);
  useEffect(() => {
    let ok = true;
    fetch('/api/services')
      .then((r) => r.json())
      .then((d) => { if (ok) { setItems(d.items || []); setLoading(false); } })
      .catch(() => { if (ok) { setItems([]); setLoading(false); } });
    return () => { ok = false; };
  }, [configVersion]);
  return { items, loading };
}
